import { QueryClient, QueryKey } from '@tanstack/react-query';

export const isQueryMountedWithData = (queryClient: QueryClient, queryKey: QueryKey): boolean => {
  const query = queryClient.getQueryCache().find({ queryKey });
  const isMounted = query?.isActive() ?? false;
  const hasData = query?.state.data !== undefined && query?.state.data !== null;
  return isMounted && hasData;
};

const LOCAL_SSE_HOSTS = new Set(['localhost', '127.0.0.1', '0.0.0.0', '::1']);

export const isSSEDisabledForUrl = (url: string): boolean => {
  try {
    return LOCAL_SSE_HOSTS.has(new URL(url, window.location.origin).hostname);
  } catch {
    return url.includes('localhost') || url.includes('127.0.0.1');
  }
};
